"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkQBYZPWDOcjs = require('./chunk-QBYZPWDO.cjs');

// src/contracts/core/Contract.ts
var Contract = class {
  
  constructor(address, options) {
    this.address = _chunkQBYZPWDOcjs.toAddress.call(void 0, address);
  }
  static create(address) {
    return new this(address);
  }
};



exports.Contract = Contract;
//# sourceMappingURL=chunk-IIMQROIV.cjs.map